import { IApplicationState } from '../../../types/types';
import { TABTestName, TABTestValue } from '../../types';
import { getInitialState } from '../helpers/getInitialState';

export const isABTestInit = (state: IApplicationState, name: TABTestName): boolean => {
    const initialState = getInitialState();
    return (state.abTesting || initialState)[name].init;
};
